import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface NavigationMenuItemClickedProps extends EventProps {
    menu_name: string
    user_type: 'adviser' | 'customer'
}

/**
 * @event navigation_menu_item_clicked
 * @description Emitted when a navigation menu item is clicked.
 */
export const NavigationMenuItemClickedAnalytics = createAnalyticsStatic<NavigationMenuItemClickedProps>(
    ANALYTICS_EVENTS.NAVIGATION_MENU_ITEM_CLICKED,
)

export default NavigationMenuItemClickedAnalytics
